// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__31QTr","box":"WorkspacesBox_box__3ni3y","node":"WorkspacesBox_node__17tcM"};